// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_pj-0";
export var discountCodeInput = "_pj-1";